import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { fetchGroupItemssFailure, fetchGroupItemssSuccess } from '../actions';
import GroupActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { API_BASE_URL } = urls || {};

function* getGroupItems() {
  const url = `${API_BASE_URL}/application-group-items`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchGroupItemssSuccess(response.raw));
  } else {
    yield put(
      fetchGroupItemssFailure(
        'An error occured. Please reload the page to try again.'
      )
    );

    networkErrorHandler(response?.statusCode, response?.message);
  }
}

export function* onGetGroupItems() {
  yield takeLatest(GroupActionTypes.START_FETCH_GROUP_ITEMS, getGroupItems);
}

//   export function * groupsSaga () {
//     yield all([call(onGetGroups)]);
//   }
